
/**
 * Utility for preloading resources to improve perceived performance
 */

/**
 * Preload a JavaScript resource
 * @param path Path to the JavaScript resource
 */
export const preloadScript = (path: string) => {
  const link = document.createElement('link');
  link.rel = 'preload';
  link.as = 'script';
  link.href = path;
  document.head.appendChild(link);
};

/**
 * Preload an image resource
 * @param src Image URL to preload
 */
export const preloadImage = (src: string) => {
  const link = document.createElement('link');
  link.rel = 'preload';
  link.as = 'image';
  link.href = src;
  document.head.appendChild(link);
};

/**
 * Preload a route for faster navigation
 * @param routePath Route to preload (e.g., '/treks')
 */
export const preloadRoute = (routePath: string) => {
  // This is a simplified implementation
  // In a real app, you would need to map routes to their chunk names
  // and then preload those specific chunks
  console.log(`Preloading route: ${routePath}`);
  
  // Example implementation based on route path
  switch (routePath) {
    case '/treks':
      // Dynamic import to trigger chunk preloading
      import('../pages/TrekListing').catch(e => console.error(e));
      break;
    case '/companies':
      import('../pages/CompanyListing').catch(e => console.error(e));
      break;
    // Add other critical routes as needed
    default:
      // Do nothing for unknown routes
      break;
  }
};

/**
 * Preload critical resources for a specific page
 * @param pageName Name of the current page to optimize for
 */
export const preloadCriticalResources = (pageName: string) => {
  switch (pageName) {
    case 'home':
      // Preload resources likely to be needed from the home page
      preloadRoute('/treks');
      preloadRoute('/companies');
      break;
    case 'trek-detail':
      // Preload resources likely to be needed from trek detail pages
      preloadRoute('/trek/:trekId/packages');
      break;
    default:
      // No specific preloading for other pages
      break;
  }
};
